module.exports = "/_next/static/images/IMG_3840-9cec79ad1d9d9422eb5a5f4d264be097.jpg";